<app-user-header class="d-lg-none"></app-user-header>


<div class="wrapperi pb-4">


    <div class="col-12 ps-3">
        <p class=" d-none d-lg-block semiboldtextblue24 mt-4">Viestit</p>
        <div class="d-block d-lg-none" *ngIf="sidebar_open == false">
            <p (click)="openSideBar()" class="link-text">Keskustelusi</p>
        </div>
    </div>

    <div class="col-12 p-0 row me-0 ms-0">
        <div class="d-none d-lg-block col-lg-4 padd-right-20" id="message-listing">
            <ul class="bg-f-w shadow-f h-100" [ngClass]="messages.length > 0 ? 'sec-height' : ''">
                <p class="semiboldtextblue80016 pt-3 ps-3">Saapuneet</p>
                <li class="p-0" id="message-list-{{data['_id']}}" *ngFor="let data of messages"
                    [ngClass]="data.unreadMessages >0 ? 'formed-list-messages-unread' : 'formed-list-messages'">
                    <div class="col-12 row  ms-0 me-0">
                        <div class="col-2 ps-3 d-flex align-items-center">
                            <div class="img-container me-4">
                                <div class="" *ngIf="data && data.user && data.user.profilePicture; else no_logo">
                                    <img src="{{data.user.profilePicture}}" class="rounded-circle"
                                        [ngClass]="data.unreadMessages >0 ? 'formed-img-unread' : 'formed-img-read'"
                                        width="40" height="40" alt="">
                                </div>
                                <ng-template #no_logo>
                                    <img src="../../assets/icons/formed_no_profile.svg" class="rounded-circle"
                                        [ngClass]="data.unreadMessages >0 ? 'formed-img-unread' : 'formed-img-read'"
                                        width="40" height="40" alt="">
                                </ng-template>
                            </div>
                        </div>
                        <div class="col-10 ps-0 pt-3">
                            <div class="col-12 row m-0 p-0" id="borderbottom-{{data['_id']}}">
                                <div class="col-8 pointer ps-0 pb-3" (click)="selectUser(data)">
                                    <div class="" *ngIf="data.unreadMessages <= 0">
                                        <p class="mb-0 semiboldtextblue80016">{{data.user.firstName}}</p>
                                        <p class="mb-0 normaltextblue80014">{{ data.messages.length > 0 ?
                                            (data.messages[0].message | truncate:10 :false) : 'Ei vielä viestejä...' }}
                                        </p>
                                    </div>
                                    <div class="" *ngIf="data.unreadMessages > 0">
                                        <p class="mb-0 semiboldtextblue80016">{{data.user.firstName}}
                                            </p>
                                        <p class="mb-0 semiboldtextblue80014">{{ data.messages.length > 0 ?
                                            (data.messages[0].message | truncate:10 : false) : 'Ei vielä viestejä...' }}
                                        </p>
                                    </div>


                                </div>
                                <div class="col-4 pe-0">
                                    <div class="" *ngIf="data.unreadMessages <= 0">
                                        <p class="normaltextblue14 text-end mb-0 mt-1">
                                            <span
                                                *ngIf="data.messages && data.messages.length > 0">{{data.messages[0]['createdDate']
                                                |formateDateMonth : 'fi'}}</span>
                                        </p>
                                    </div>
                                    <div class="" *ngIf="data.unreadMessages > 0">
                                        <p class="normaltextblue14 text-end mb-0 mt-1">
                                            <span
                                                *ngIf="data.messages && data.messages.length > 0">{{data.messages[0]['createdDate']
                                                | formateDateMonth : 'fi'}}</span>
                                        </p>
                                    </div>


                                    <div class="" *ngIf="data.unreadMessages <=0">
                                        <div class="" *ngIf="data.messages && data.messages.length > 0">
                                            <div class="d-flex justify-content-end"
                                                *ngIf="data.messages[0].reciever_has_read; else not_read_img">
                                                <div class="blue-ball">

                                                </div>
                                            </div>
                                            <ng-template #not_read_img>

                                            </ng-template>
                                        </div>
                                    </div>
                                    <div *ngIf="data.unreadMessages > 0" class="d-flex justify-content-end mt-2">
                                        <div class="ball-30 d-flex justify-content-center align-items-center">
                                            <p class=" mb-0">{{data.unreadMessages}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </li>
                <ng-container *ngIf="messages.length < 5">
                    <div class="p-4  mt-4 ">
                        <div class="text-center flex-column justify-content-center mt-4">
                            <img src="../../assets/icons/no_messages.svg" style="width: 80%;" alt="">

                        </div>
                    </div>
                </ng-container>
            </ul>
        </div>
        <div id="message-view" class="col-12 d-lg-block col-lg-8 ps-0 pe-0 formed-msg-card wrapper-height"
            *ngIf="messages.length > 0;else no_messages_added">
            <div class="col-12  h-100 p-0" id="main-chat-container">
                <div class="chat-header padd-20 d-flex align-items-center">
                    <div class="col-12 row m-0 p-0 d-flex align-items-center bg-chat height65">
                        <div class="col-7 ps-0 border-card" *ngIf="currentActiveUser">
                            <div class="d-inline-flex ">
                                <div class="img-conts ps-2">
                                    <div *ngIf="currentActiveUser['profilePicture']; else not_installed_profile_picture"
                                    class="d-flex align-items-center">
                                    <img src="{{currentActiveUser['profilePicture']}}" class="rounded-circle" width="40"
                                        height="40" alt="">
                                </div>
                                <ng-template #not_installed_profile_picture>
                                    <div class="d-flex align-items-center">
                                        <img src="../../assets/icons/formed_no_profile.svg" class="rounded-circle"
                                            width="40" height="40" alt="">
                                    </div>
                                </ng-template>
                                </div>
                                <div class="d-flex align-items-center ps-3">
                                    <p class="mb-0 semiboldtextblue80016">{{currentActiveUser.firstName}}
                                        </p>

                                </div>

                            </div>
                        </div>
                        <div class="col-5" *ngIf="currentActiveUser">
                            <div class="d-flex"
                                *ngIf="messageList['opening'] && messageList['opening']['type'] == 'application'">


                                <div class="dropdown col text-end d-flex justify-content-end">
                                    <img src="../../assets/icons/ellips.svg" data-bs-toggle="dropdown"
                                        aria-expanded="false"/>
                                    
                                    <ul class="dropdown-menu formed-shadow">
                                        <li class="ddm-item"
                                            routerLink="/{{businessID}}/openings/profile-opened/{{messageList['opening']['type']}}/{{messageList['opening']['openingID']}}/{{messageList['user']['userID']}}">
                                            <p class="normaltextblue80016 mb-1">Profiili</p>
                                        </li>
                                        <li class="ddm-item"
                                            routerLink="/{{businessID}}/openings/single-opening/{{messageList['opening']['openingID']}}">
                                            <p class="normaltextblue80016 mb-1">Työpaikka</p>
                                        </li>
                                        <li class="ddm-item" data-bs-toggle="modal" type="button"
                                            data-bs-target="#open-profile-modal">
                                            <p class="normaltextblue80016 mb-1">Poista keskustelu</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="d-flex"
                                *ngIf="messageList['opening'] && messageList['opening']['type'] == 'wishlist'">
                                <div class="dropdown col text-end d-flex justify-content-end">
                                    <i class="fad fa-ellipsis-v blue-icon icon-dot pointer" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                    </i>
                                    <ul class="dropdown-menu formed-shadow">
                                        <li class="ddm-item"
                                            routerLink="/{{businessID}}/openings/profile-opened/{{messageList['opening']['type']}}/{{messageList['opening']['openingID']}}/{{messageList['user']['userID']}}">
                                            <p class="normaltextblue80016 mb-1">Profiili</p>
                                        </li>
                                        <li class="ddm-item" data-bs-toggle="modal" type="button"
                                            data-bs-target="#open-profile-modal">
                                            <p class="normaltextblue80016 mb-1">Poista keskustelu</p>
                                        </li>
                                    </ul>
                                </div>
                                <!--                             <div class="col text-end d-flex justify-content-end me-3">
                                <button class="btn btn-formed-main-white" routerLink="/{{businessID}}/openings/profile-opened/{{messageList['opening']['type']}}/{{messageList['opening']['openingID']}}/{{messageList['user']['userID']}}">Profiili</button>
                            </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="chat-window-main-container">
                    <div class="msg-wrapper" #chatMessageContainer>
                        <ng-container *ngIf="messageList">

                            <ng-container *ngFor="let msg of messageList.messages">
                                <!-- IF Customer sends message -->
                                <div class="col-12 no-padding mt-2" *ngIf="msg.to == currentUserId">
                                    <div class="col-md-12 p-0">
                                        <div class="row m-0">


                                            <div class="col-10 col-md-6 col-lg-6 col-xl-5 p-0 mt-3 ms-2 me-2 mb-0">
                                                <div class="d-flex justify-content-start p-0">
                                                    <div class="d-flex align-items-end">
                                                    </div>
                                                    <div
                                                        class="text-message ms-2 text-message-left-doctor whitespace-preline">


                                                        <div>
                                                            <div class="body2 break-word text-container">
                                                                <p class="normaltextgray70016 mb-1">{{msg.message}}</p>
                                                                <div class="d-flex justify-content-end ps-4">
                                                                    <p class="text-message-time-left pe-2  mb-0">
                                                                        {{msg.createdDate | chatTimeIndicator}}</p>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1 col-lg-5 col-xl-6"></div>
                                        </div>
                                    </div>
                                    <div class="col-12 p-0 m-0 row ">

                                        <!--                         <p class="text-message-time-left mt-2  mb-0">{{msg.createdDate | chatTimeIndicator}}</p>
        -->
                                    </div>
                                </div>
                                <div class="col-md-12 pe-2 mb-2 mt-2" *ngIf=" msg.to != currentUserId ">
                                    <div class="row m-0">
                                        <div class="col-md-2 col-3">
                                            <p class="d-none">To take some space</p>
                                        </div>
                                        <div class="col-md-10 col-9 p-0">
                                            <div class="d-flex justify-content-end p-0">
                                                <div class="text-message text-message-right whitespace-preline me-2">

                                                    <p class="normaltextwhite16 mb-1 break-word">{{msg.message }}</p>
                                                    <div class="d-flex justify-content-end ps-0">
                                                        <p class="text-message-time pe-2  mb-0">{{msg.createdDate |
                                                            chatTimeIndicator}}</p>
                                                        <ng-container *ngIf="msg.reciever_has_read; else msg_not_read">
                                                            <img width="15"
                                                                src="../../assets/icons/message_is_read_gray_bg.svg">
                                                        </ng-container>
                                                        <ng-template #msg_not_read>
                                                            <img width="15"
                                                                src="../../assets/icons/message_not_read.svg">

                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 m-0 ">
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>


                </div>

                <div *ngIf="currentActiveUser">
                    <div class="row col-12 reply me-0 ms-0 mt-4 col-12 p-0 pt-1 pb-1 ps-2">

                        <div class="col-10 ps-2 reply-main ps-0 pe-0 mt-2">
                            <textarea class="send-message-input" autocomplete="off" rows="1"
                                (keydown)="autoTextarea($event)" id="comment"
                                placeholder="Kirjoita viestisi tähän..."></textarea>
                        </div>
                        <div class="col-2 col-md-2 d-flex justify-content-center  mt-1 mt-md-1">
                            <div class="send-btn-container pointer text-center mt-1" (click)="OnSendReply($event)">
                                <div class="d-flex align-items-center">
                                    <img src="../../assets/icons/sb_messages.svg" class="send-message-icon" alt="">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div>
        <ng-template #no_messages_added>
            <div class="col-12 d-lg-block p-4 col-lg-8  bg-f-w formed-shadow">
                <p class="semiboldtextblue24">Miten saat viestejä?</p>
                <p class="normaltextblue80016">Avataksesi keskustelun työnhakijoiden kanssa kokeile seuraavia: </p>
                <p class="semiboldlinkblue16"><a routerLink="/{{businessID}}/openings/add-opening/standard">Lisää
                        työpaikka</a></p>
                <p class="normaltextblue80016">Kun olet lisännyt työpaikkailmoituksia, hakijat voivat osoittaa
                    kiinnostuksensa niitä kohtaan. Työpaikat- välilehdeltä näet kaikki työpaikoistasi kiinnostuneet
                    hakijat. Voit avata työpaikastasi kiinnostuneen työnhakijan profiilin ja lähettää hänelle viestin.
                </p>
                <p class="semiboldlinkblue16"><a routerLink="/{{businessID}}//wishlists">Selaa toiveita</a></p>
                <p class="normaltextblue80016">Uusimmat Formed-palveluun jätetyt Toiveet näet työpöydältäsi. Toiveet-
                    välilehdeltä löydät kaikki palveluun lisätyt työtoiveet ja voit rajata Toiveiden hakua esimerkiksi
                    ammattiryhmän perusteella.Kun löydät sinulle sopivan tai sinua kiinnostavan Toiveen, voit avata
                    keskustelun työnhakijan kanssa avaamalla Toive-kortin ja valitsemalla "Lähetä viesti". </p>
            </div>
        </ng-template>



    </div>

</div>



<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="open-profile-btn" data-bs-target="#open-profile-modal" style="display:none"></button>
<div class="modal fade" id="open-profile-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title mt-2" id="exampleModalLabel">Poista keskustelu</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button id="close-open-profile" type="button" id="close-modal-open" class="btn-close"
                    data-bs-dismiss="modal">
                    <i class="fal fa-times"></i>
                </button>
            </div>
            <div class="modal-body p-4" *ngIf="currentActiveUser">
                <div class="bg-blue">
                    <div class="col-12 row m-0 p-4">
                        <div class="col-lg-2">
                            <div *ngIf="currentActiveUser.profilePicture;else no_profile_pic" class="">
                                <img src="{{currentActiveUser.profilePicture}}" class="rounded-circle" width="45"
                                    height="45" alt="">
                            </div>
                            <ng-template #no_profile_pic>
                                <img src="../../assets/icons/formed_no_profile.svg" class="rounded-circle" width="45"
                                    height="45" alt="">
                            </ng-template>
                        </div>
                        <div class="col-12 col-lg-9 justify-content-center flex-column d-flex">
                            <p class="semiboldtextwhite16 mb-0">{{currentActiveUser.firstName}}</p>

                        </div>
                    </div>
                </div>
                <p class="normaltextblue80016 mt-2">Oletko varma, että haluat poistaa keskustelun? Tämä toiminto poistaa
                    kaikki sinun ja ammattilaisen väliset keskustelut pysyvästi. Toimintoa ei voi peruuttaa.</p>





                <div class="text-center justify-content-center d-flex col-12 ">
                    <button class="btn btn-formed-main-blue mt-2" (click)="removeMessageList()">Poista</button>
                </div>

            </div>
        </div>
    </div>
</div>